import React from "react";
import { HeaderComponent } from "../Config/header";
import { FooterComponent } from "../Config/footer";
import { Link } from "react-router-dom";

const Menu = () => {
  return (
    <div>
      <HeaderComponent></HeaderComponent>

      <div className="container" style={{ marginBottom: "100px" }}>
        <div className="row g-4 ">
          <div className="col-4">
            <Link to="/Attendance">
              <div
                className="card text-center border-0 p-3"
                style={{ height: "100%" }}
              >
                <div
                  className="rounded-circle  d-flex align-items-center justify-content-center mx-auto"
                  style={{
                    width: "65px",
                    height: "65px",
                    backgroundColor: "#0010a4",
                  }}
                >
                  <i className="fa-solid fa-clipboard-user fs-5x text-white"></i>
                </div>
                <div className="card-body p-0">
                  <p className="card-title mt-3">Attendance</p>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-4">
            <Link to="/ChangePassword">
              <div
                className="card text-center border-0 p-3"
                style={{ height: "100%" }}
              >
                <div
                  className="rounded-circle  d-flex align-items-center justify-content-center mx-auto"
                  style={{
                    width: "65px",
                    height: "65px",
                    backgroundColor: "#a3cb82",
                  }}
                >
                  <i className="fa-solid fa-key fs-5x text-white"></i>
                </div>
                <div className="card-body p-0">
                  <p className="card-title mt-3">Change Password</p>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-4">
            <Link to="/Subscribe">
              <div
                className="card text-center border-0 p-3"
                style={{ height: "100%" }}
              >
                <div
                  className="rounded-circle  d-flex align-items-center justify-content-center mx-auto"
                  style={{
                    width: "65px",
                    height: "65px",
                    backgroundColor: "#7c7b29",
                  }}
                >
                  <i className="fa-solid fa-table-list fs-5x text-white"></i>
                </div>
                <div className="card-body p-0">
                  <p className="card-title mt-3">Leave Summary</p>
                </div>
              </div>
            </Link>
          </div>

          <div className="col-4">
            <Link to="/Subscribe">
              <div
                className="card text-center border-0 p-3"
                style={{ height: "100%" }}
              >
                <div
                  className="rounded-circle  d-flex align-items-center justify-content-center mx-auto"
                  style={{
                    width: "65px",
                    height: "65px",
                    backgroundColor: "#7c7b29",
                  }}
                >
                  <i className="fa-solid fa-umbrella-beach fs-5x text-white"></i>
                </div>
                <div className="card-body p-0">
                  <p className="card-title mt-3">Holidays</p>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-4">
            <Link to="/Subscribe">
              <div
                className="card text-center border-0 p-3"
                style={{ height: "100%" }}
              >
                <div
                  className="rounded-circle  d-flex align-items-center justify-content-center mx-auto"
                  style={{
                    width: "65px",
                    height: "65px",
                    backgroundColor: "#ffa269",
                  }}
                >
                  <i className="fa-solid fa-message fs-5x text-white"></i>
                </div>
                <div className="card-body p-0">
                  <p className="card-title mt-3">Chat</p>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-4">
            <Link to="/Subscribe">
              <div
                className="card text-center border-0 p-3"
                style={{ height: "100%" }}
              >
                <div
                  className="rounded-circle  d-flex align-items-center justify-content-center mx-auto"
                  style={{
                    width: "65px",
                    height: "65px",
                    backgroundColor: "#00a2a1",
                  }}
                >
                  <i className="fa-solid fa-money-bill-transfer fs-5x text-white"></i>
                </div>
                <div className="card-body p-0">
                  <p className="card-title mt-3">Expenses</p>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-4">
            <Link to="/Subscribe">
              <div
                className="card text-center border-0 p-3"
                style={{ height: "100%" }}
              >
                <div
                  className="rounded-circle  d-flex align-items-center justify-content-center mx-auto"
                  style={{
                    width: "65px",
                    height: "65px",
                    backgroundColor: "#eda400",
                  }}
                >
                  <i className="fa-solid fa-id-card-clip fs-5x text-white"></i>
                </div>
                <div className="card-body p-0">
                  <p className="card-title mt-3"> Visitor Pass</p>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-4">
            <Link to="/Subscribe">
              <div
                className="card text-center border-0 p-3"
                style={{ height: "100%" }}
              >
                <div
                  className="rounded-circle  d-flex align-items-center justify-content-center mx-auto"
                  style={{
                    width: "65px",
                    height: "65px",
                    backgroundColor: "#79aeda",
                  }}
                >
                  <i className="fa-solid fa-handshake fs-5x text-white"></i>
                </div>
                <div className="card-body p-0">
                  <p className="card-title mt-3">Meeting Schedule</p>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-4">
            <Link to="/Subscribe">
              <div
                className="card text-center border-0 p-3"
                style={{ height: "100%" }}
              >
                <div
                  className="rounded-circle  d-flex align-items-center justify-content-center mx-auto"
                  style={{
                    width: "65px",
                    height: "65px",
                    backgroundColor: "#bf0048",
                  }}
                >
                  <i className="fa-solid fa-photo-film fs-5x text-white"></i>
                </div>
                <div className="card-body p-0">
                  <p className="card-title mt-3">Gallery</p>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-4">
            <Link to="/Subscribe">
              <div
                className="card text-center border-0 p-3"
                style={{ height: "100%" }}
              >
                <div
                  className="rounded-circle  d-flex align-items-center justify-content-center mx-auto"
                  style={{
                    width: "65px",
                    height: "65px",
                    backgroundColor: "#f17bb5",
                  }}
                >
                  <i className="fa-solid fa-pen-to-square fs-5x text-white"></i>
                </div>
                <div className="card-body p-0">
                  <p className="card-title mt-3">Update Profile</p>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-4">
            <Link to="/Subscribe">
              <div
                className="card text-center border-0 p-3"
                style={{ height: "100%" }}
              >
                <div
                  className="rounded-circle  d-flex align-items-center justify-content-center mx-auto"
                  style={{
                    width: "65px",
                    height: "65px",
                    backgroundColor: "#8A8730",
                  }}
                >
                  <i className="fa-solid fa-folder-open fs-5x text-white"></i>
                </div>
                <div className="card-body p-0">
                  <p className="card-title mt-3">Reports</p>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-4">
            <Link to="/Subscribe">
              <div
                className="card text-center border-0 p-3"
                style={{ height: "100%" }}
              >
                <div
                  className="rounded-circle  d-flex align-items-center justify-content-center mx-auto"
                  style={{
                    width: "65px",
                    height: "65px",
                    backgroundColor: "#00a2a1",
                  }}
                >
                  <i className="fa-solid fa-receipt fs-5x text-white"></i>
                </div>
                <div className="card-body p-0">
                  <p className="card-title mt-3">Pay Slips</p>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-4">
            <Link to="/About">
              <div
                className="card text-center border-0 p-3"
                style={{ height: "100%" }}
              >
                <div
                  className="rounded-circle  d-flex align-items-center justify-content-center mx-auto"
                  style={{
                    width: "65px",
                    height: "65px",
                    backgroundColor: "#eda400",
                  }}
                >
                  <i className="fa-solid fa-circle-info fs-5x text-white"></i>
                </div>
                <div className="card-body p-0">
                  <p className="card-title mt-3">About Us</p>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
      <FooterComponent></FooterComponent>
    </div>
  );
};

export default Menu;
